import React from 'react';

import type { TypeSelectOption } from '@thefarmersfront/kitchen';

import styles from './ReceiveCustomRenderFunctions.module.scss';

export const renderOperationTimesSelect = (value: TypeSelectOption<string> | null, isDisabled: boolean) => {
  if (!value?.text) {
    return (
      <div
        className={`${styles['label-renderer-container']} ${styles['placeholder']} 
          ${isDisabled ? styles['disabled'] : ''}`}
      >
        시간 선택
      </div>
    );
  }

  const regex = /(\d{1,3}(?:,\d{3})*|(?<!\d)\d+)(종|개)/g;

  const parts = value.text.split(regex).reduce<React.ReactNode[]>((acc, part, index) => {
    if (index % 3 === 1) {
      acc.push(
        <span key={`${value.value}-${index}`} className={styles['highlight']}>
          {part}
        </span>
      );
    } else if (part) {
      acc.push(part);
    }
    return acc;
  }, []);

  return <div className={styles['label-renderer-container']}>{parts}</div>;
};

export const renderOperationTimesDropdown = (
  option: TypeSelectOption<string>,
  isDisabled: boolean,
  isSelected: boolean
) => {
  const regex = /(\d{1,3}(?:,\d{3})*|(?<!\d)\d+)(종|개)/g;

  const parts = option.text.split(regex).reduce<React.ReactNode[]>((acc, part, index) => {
    if (index % 3 === 1) {
      acc.push(
        <span
          key={`${option.value}-${index}`}
          className={`${styles['highlight']}
          ${isDisabled ? styles['disabled'] : ''}
          ${isSelected ? styles['selected'] : ''}`}
        >
          {part}
        </span>
      );
    } else if (part) {
      acc.push(part);
    }
    return acc;
  }, []);

  return (
    <div
      className={`${styles['dropdown-renderer-container']}
      ${isDisabled ? styles['disabled'] : ''}
      ${isSelected ? styles['selected'] : ''}`}
      tabIndex={isDisabled ? -1 : 0}
    >
      {parts}
    </div>
  );
};
